<ix-typography class="mb-1">{{ label }}</ix-typography>
